import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { userReducer } from './userSlice';
import { customerReducer } from './customersSlice';
import { prescriptionReducer } from './prescriptionSlice';
import { ChatReducer } from './ChatSlice';

import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from 'redux-persist';
import { notificationReducer } from './NotificationSlice';


const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: [
    "customer",
    "prescription",
    "chat",
    "notification"
  ],
};

const rootReducer = combineReducers({
  user: userReducer,
  customer: customerReducer,
  prescription: prescriptionReducer,
  chat: ChatReducer,
  notification: notificationReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
